module.exports = __webpack_public_path__ + "static/media/adrian.289d3e19.jpg";